var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoOnly(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 405,
    height: 134,
    viewBox: "0 0 405 134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.1206 76.8677L107.647 111.667H78.8375L45.6167 76.8677",
    fill: "#A6AEAD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M107.647 47.4255H127.813V111.621H107.647V47.4255V47.4255Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1206 76.8676L107.647 47.4257V21L73.1206 50.4419V76.8676Z",
    fill: "#C41DFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M180.165 47.4255H202.358L175.079 111.757H157.298L130.019 47.4255H152.211L166.256 85.736L180.165 47.4255Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M263.127 85.6011H215.997C217.933 91.8136 223.289 95.6401 231.032 95.6401C237.109 95.6401 243.276 92.894 247.282 89.0225L257.77 102.258C251.423 109.146 240.395 113.422 229.681 113.422C209.29 113.422 194.975 99.3767 194.975 79.7938C194.975 58.8603 211.09 45.76 229.546 45.76C248.002 45.76 263.442 58.7252 263.442 78.2631C263.397 80.1089 263.262 82.4498 263.127 85.6011ZM243.141 73.6263C242.871 67.2787 237.199 63.002 229.906 63.002C223.829 63.002 217.933 65.8831 215.862 73.6263H243.141Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M361.079 46.9304H380.885V111.261H361.079L360.494 103.113C356.082 109.191 348.25 112.882 340.102 112.882C322.051 112.882 309.357 99.2415 309.357 79.1184C309.357 58.8602 322.051 45.2197 340.372 45.2197C348.205 45.2197 356.082 48.6861 360.494 54.5835L361.079 46.9304ZM359.819 79.2084C359.819 70.79 353.201 64.1724 344.919 64.1724C336.231 64.1724 330.199 70.9251 330.199 79.2084C330.199 87.0416 336.276 94.1095 345.099 94.1095C353.336 94.0644 359.819 87.0416 359.819 79.2084Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M303.1 65.838C305.621 65.838 307.782 66.0181 309.357 66.3332V45.8049C299.364 45.985 292.072 50.5769 287.66 59.4454L286.715 61.2912L284.959 47.4256H266.503V111.802H287.12V83.5302C287.12 65.838 297.923 65.838 303.1 65.838Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25 38.5571V111.622H25.2251H45.3916H45.6167V21L25 38.5571Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoOnly);
export default __webpack_public_path__ + "static/media/logo-only.c2ef55d3.svg";
export { ForwardRef as ReactComponent };